<template>
  <div class="index_down_vue" style="padding-top: 40px">
    <el-row>
      <el-row>
        <el-col :span="12">
          <div class="zd_item_img">
            <router-link to="/announcementDynamics/mediaFocus"><img class="img_cla" src="~@/assets/img/index/mtjj.webp"
                                                                    width="596px" height="320px"></router-link>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="zd_item_img">
            <router-link to="/newsInformation/videoList"><img class="img_cla" src="~@/assets/img/index/jcsp.webp" width="596px"
                                                    height="320px">
            </router-link>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <div class="zd_item_img">
            <router-link to="/announcementDynamics/informationDisclosure"><img class="img_cla"
                                                                               src="~@/assets/img/index/xxgk.webp"
                                                                               width="596px" height="320px">
            </router-link>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="zd_item_img">
            <router-link to="/announcementDynamics/honestAdministration"><img class="img_cla"
                                                                              src="~@/assets/img/index/lzjd.webp"
                                                                              width="596px" height="320px">
            </router-link>
          </div>
        </el-col>
      </el-row>
    </el-row>
    <el-row style="margin-top: 20px">
      <div class="common_title" style="width: 100%">
        <img src="~@/assets/img/index/yyhj.png" height="25" width="30" style="position: relative;top: 5px"/>
        <span class="active_span">医院环境</span>
        <hr>
      </div>
      <el-row style="padding-top: 20px" class="yyhj_div">
        <el-col :span="8">
          <div style="overflow: hidden;width: 390px;height: 383px">
            <img class="img_cla" v-if="envirImgList.length>=1" :src="'https://www.lcjfzx.cn/'+'/imgUrl/'+envirImgList[0].photo.split('/')[3]" width="100%" height="100%">
          </div>
        </el-col>
        <el-col :span="16">
          <el-row>
            <el-col :span="12">
              <div style="overflow: hidden;width: 395px;height: 206px">
                <img class="img_cla" v-if="envirImgList.length>=2" :src="'https://www.lcjfzx.cn/'+'/imgUrl/'+envirImgList[1].photo.split('/')[3]" width="100%" height="100%">
              </div>
            </el-col>
            <el-col :span="12" align="right">
              <div style="overflow: hidden;width: 395px;height: 206px">
                <img class="img_cla" v-if="envirImgList.length>=3" :src="'https://www.lcjfzx.cn/'+'/imgUrl/'+envirImgList[2].photo.split('/')[3]" width="100%" height="100%">
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <div style="overflow: hidden;width: 258px;height: 173px">
                <img class="img_cla" v-if="envirImgList.length>=4" :src="'https://www.lcjfzx.cn/'+'/imgUrl/'+envirImgList[3].photo.split('/')[3]"  width="100%" height="100%">
              </div>
            </el-col>
            <el-col :span="8">
              <div style="overflow: hidden;width: 265px;height: 173px">
                <img class="img_cla" v-if="envirImgList.length>=5" :src="'https://www.lcjfzx.cn/'+'/imgUrl/'+envirImgList[4].photo.split('/')[3]" width="265px" height="173px">
              </div>
            </el-col>
            <el-col :span="8" align="right">
              <div style="overflow: hidden;width: 258px;height: 173px">
                <img class="img_cla" v-if="envirImgList.length>=6" :src="'https://www.lcjfzx.cn/'+'/imgUrl/'+envirImgList[5].photo.split('/')[3]"  width="100%" height="100%">
              </div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </el-row>
    <!--<el-row style="margin-top: 50px">
      <div class="common_title2">
        <span class="active_span">友情链接</span>
      </div>
      <el-row style="padding-top: 20px">

        <el-col style="width: 20%">
          <div class="hz_company">
            <a href="https://www.jdzx.net.cn/" target="_blank">
              &lt;!&ndash;<img width="73px" height="73px" src="../../../../assets/img/newIndex/国家卫生健康委卫生健康监督中心.png"/>&ndash;&gt;
            </a>
          </div>
          <div class="name_div">南部山区管委会</div>
        </el-col>
        <el-col style="width: 20%">
          <div class="hz_company">
            <a href=" http://www.satcm.gov.cn/" target="_blank">
              &lt;!&ndash;<img width="73px" height="73px" src="../../../../assets/img/newIndex/国家中医药管理局.png"></img>&ndash;&gt;
            </a>
          </div>
          <div class="name_div">济南市卫生健康委员会</div>
        </el-col>
        <el-col style="width: 20%">
          <div class="hz_company">
            <a href="http://jnmhc.jinan.gov.cn/" target="_blank">
              &lt;!&ndash;<img width="73px" height="73px" src="../../../../assets/img/newIndex/山东省精神卫生中心.png"></img>&ndash;&gt;
            </a>
          </div>
          <div class="name_div">山东省精神卫生中心</div>
        </el-col>
        <el-col style="width: 20%">
          <div class="hz_company">
            <a href="http://www.sdsjsx.org.cn/" target="_blank">
              &lt;!&ndash;<img width="73px" height="73px" src="../../../../assets/img/newIndex/济南市计划生育委员会.png"></img>&ndash;&gt;
            </a>
          </div>
          <div class="name_div">济南市政府</div>
        </el-col>
        <el-col style="width: 20%">

          <div class="hz_company">
            <a href="http://jnfpa.jinan.gov.cn/" target="_blank">
              &lt;!&ndash;<img width="73px" height="73px" src="../../../../assets/img/newIndex/济南市计划生育委员会.png"></img>&ndash;&gt;
            </a>
          </div>
          <div class="name_div">历城区人民医院</div>

        </el-col>
      </el-row>
    </el-row>-->
    <el-row :gutter="5" style="margin-top: 15px;">
      <el-col :span="2">
        <div class="grid-content ">
          友情链接：
        </div>
      </el-col>
      <el-col :span="4">
        <div class="grid-content ">
          <a class="yqlj" href="http://www.jinan.gov.cn/" target="_blank">
            济南市人民政府
          </a>
        </div>
      </el-col>
      <el-col :span="5">
        <div class="grid-content ">
          <a class="yqlj" href="http://jnns.jinan.gov.cn/" target="_blank">
            济南市南部山区管理委员会
          </a>
        </div>
      </el-col>
      <el-col :span="4">
        <div class="grid-content ">
          <a class="yqlj" href="http://www.sdmhc.com/" target="_blank">
            山东省精神卫生中心
          </a>
        </div>
      </el-col>
      <el-col :span="5">
        <div class="grid-content ">
          <a class="yqlj" href="http://jnmhc.jinan.gov.cn/" target="_blank">
            济南市卫生健康委员会
          </a>
        </div>
      </el-col>
      <el-col :span="4">
        <div class="grid-content ">
          <a class="yqlj" href="http://wang58821.honpu.com/" target="_blank">
            济南市历城区人民医院
          </a>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import Swiper from "swiper";
  import Qs from 'qs';

  export default {
    name: "index-down-vue",
    data() {
      return {
        imgFlag: 1,
        departmentList: [],
        doctorList: [],
        doctorListZM: [],
        left: 0,
        setTime: {},
        imagesList: [],
        envirImgList: [],
        pageable:{
          page: 0,
          size: 6,
          type:'3',
        }
      }
    },
    created() {
      //this.getDataList();
    },
    methods: {
      getImg: function () {
        this.service.fetch(
          '/images/getMidImg',
        ).then(res => {
          console.log(res)
          this.imagesList = res;
        })
      },
      getDataList: function () {
        this.service.fetch(
          '/departments/getKeyDepartments',
        ).then(res => {
          this.departmentList = res;
        })
      },
      tokeyDepartMents: function (val, id) {
        //设置激活按钮样式
        this.$store.dispatch('departmentIdAction', id)
        this.$router.push({
          path: val,
          query: {id: id}
        })
      },
      changeImg: function (val) {
        this.imgFlag = val;
      },
      getDoctorList: function () {
        this.service.post(
          '/doctors/findAll',
        ).then(res => {
          this.doctorList = res;
          for (let i = 0; i < this.doctorList.length; i++) {
            if (this.doctorList[i].isFamousExpert == 1) {
              this.doctorListZM.push(this.doctorList[i]);
            }
          }
          this.addAnimateNew({$el: {id: 'pane-first'}});
        })
      },
      toDoctorDetail: function (doctor) {
        let doctorStr = JSON.stringify(doctor);
        this.$router.push({
          path: '/department/doctorDetail',
          query: {
            doctor: doctorStr
          }
        })
      },
      addAnimateNew: function (tab) {
        let that = this;
        console.log(tab.$el.id);
        that.setTime = tab.$el.id;
        setTimeout(function () {
          if (that.doctorList.length > 8 && tab.$el.id == 'pane-first') {
            new Swiper("#swiper1", {
              initialSlide: 0,
              freeMode: false,
              loop: true,
              slidesPerView: 'auto',
              autoplay: {
                disableOnInteraction: false,
                delay: 1500,
                stopOnLastSlide: false,
              },
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
                hideOnClick: true,
              },
            });
          }
          if (that.doctorListZM.length > 8 && tab.$el.id == 'pane-second') {
            new Swiper("#swiper2", {
              initialSlide: 0,
              freeMode: false,
              loop: true,
              slidesPerView: 'auto',
              autoplay: {
                disableOnInteraction: false,
                delay: 1500,
                stopOnLastSlide: false,
              },
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
                hideOnClick: true,
              },
            });
          }
        }, 2000)

      },
      moveLeft: function () {
        this.left -= 145;
        $('#doctor1').animate({left: this.left + 'px'}, 1500, function () {
          /*$('#doctor1').children('.doctor_div:first').remove();*/

        })

      },
      moveright: function () {
        this.left += 145;
        $('#doctor1').animate({left: this.left + 'px'}, 1500, function () {
          /*$('#doctor1').children('.doctor_div:first').remove();*/

        })
      },
      getEnvirImgList: function () {
        let that = this;
        let data = Qs.stringify(this.pageable)
        this.service.post('/images/s', data)
          .then(function (response) {
            console.log('............');
            console.log(response.data);
            that.envirImgList = response.data;
          })
      }
    }
    ,
    mounted() {
      let that = this;
      let setTime = {};
      setTime = setInterval(function () {
        if (that.imgFlag >= 4) {
          that.imgFlag = 1;
        } else {
          that.imgFlag = that.imgFlag + 1;
        }
      }, 3000)
      $('.zd_item_img').hover(function () {
        clearInterval(setTime);
      }, function () {
        setTime = setInterval(function () {
          if (that.imgFlag >= 4) {
            that.imgFlag = 1;
          } else {
            that.imgFlag = that.imgFlag + 1;
          }
        }, 3000)
      })
      that.getDoctorList();
      that.getImg();
      that.getEnvirImgList();
    }
  }
</script>

<style scoped lang="scss">
  .zd_item_img {
    overflow: hidden;
    width: 596px;
    height: 320px;
    margin-bottom: 5px;
  }

  .img_cla {
    transition: all 0.6s;
  }

  .img_cla:hover {
    transform: scale(1.4);
  }

  .hz_company {
    width: 73px;
    height: 73px;
    // border:1px solid rgba(31,80,173,1);
    // border-radius:50%;
    margin: 0 auto;
  }

  .name_div {
    text-align: center;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: normal; //licy modify bold -> normal
    color: rgba(102, 102, 102, 1);
    padding: 0 10px;
    margin-top: 15px;
  }

  .yyhj_div {
    height: 394px;
  }

  .maBanner {
    display: block;
  }

  .index_hover_change {
    width: 230px;
    height: 56px;
    line-height: 56px;
    text-align: center;
    background-color: #d4e9ff;
    display: block;
    color: #0096ff;
    cursor: pointer;
    font-size: 20px;
    font-weight: 600;

    .iconfont {
      font-size: 21px;
    }
  }

  .index_hover_change:hover {
    background-color: #0096ff;
    color: #ffffff;
  }

  .cus_div {
    span {
      cursor: pointer;
    }
  }

  .a_cla {
    margin-right: 8px;
    font-size: 14px;
    color: #0087cd;
    border: none;
    background: none;
    position: absolute;
    right: 0;
    top: 11px;
    cursor: pointer;
    z-index: 100;
  }

  .doctors_div {
    width: 145*8px;

    .but_div {
      width: 20px;
      height: 75px;
      text-align: center;
      line-height: 50px;
      font-size: 20px;
      position: absolute;
      z-index: 10;
      top: 25%;
      cursor: pointer;
    }

    .left_div {
      background: url("~@/assets/img/index/button_left.gif");
      background-size: 100% 100%;
      left: 0;
    }

    .right_div {
      background: url("~@/assets/img/index/button_right.gif");
      background-size: 100% 100%;
      right: 0;
    }

    .doctor_div {
      width: 135px;
      height: 235px;
      padding: 0 5px;

      .name {
        text-align: center;
      }
    }
  }

  .zd_parent_div {
    height: 349px;
    position: absolute;
    right: 0;

    div {
      float: left;
    }

    .zd_item_div {
      height: 342px;
      overflow: hidden;
      margin-right: 1px;

      .zd_item_name {
        cursor: pointer;
        width: 62px;
        height: 342px;
        animation: nameShow 1.5s;
        -webkit-animation: nameShow 1.5s; /* Safari 和 Chrome */
        animation-iteration-count: 1;
        -webkit-animation-iteration-count: 1;
        animation-fill-mode: forwards;
        -webkit-animation-fill-mode: forwards;
      }
    }
  }

  @-webkit-keyframes imgShow {
    from {
      width: 0px;
    }
    to {
      width: 450px;
    }
  }

  @-webkit-keyframes imgHid {
    from {
      width: 450px;
    }
    to {
      width: 0px;
    }
  }

  @-webkit-keyframes nameShow {
    from {
      width: 0px;
    }
    to {
      width: 62px;
    }
  }

  @-webkit-keyframes nameHid {
    from {
      width: 62px;
    }
    to {
      width: 0px;
    }
  }

  .grid-content {
    text-align: center;
    color: #333333;
    font-size: 14px;
    font-family: Microsoft YaHei;
  }

  .yqlj {
    text-decoration: none;
    /*color: #333333;*/
  }
</style>



// WEBPACK FOOTER //
// src/pages/mainView/index/components/indexDownVue.vue